import { Component, Input, inject } from '@angular/core';
import { ProductDataService } from '../../services/product-data.service';
import { CurrencyPipe } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-display-price-per-user',
  imports: [CurrencyPipe, NgxSkeletonLoaderModule, TranslocoPipe],
  templateUrl: './display-price-per-user.component.html',
})
export class DisplayPricePerUserComponent {
  protected readonly productDataService = inject(ProductDataService);

  @Input() unitPrice: number;
  @Input() totalPriceWithoutTaxAndDiscount: number;
  @Input() loading: boolean;
}
